/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { GetFragmentDetailTranscriptionQueryResponse, GetFragmentDetailTranscriptionPathParams, GetFragmentDetailTranscription404 } from "../models/GetFragmentDetailTranscription";
import type { QueryKey, QueryClient, UseSuspenseQueryOptions, UseSuspenseQueryResult } from "@tanstack/react-query";
import { getFragmentDetailTranscription } from "../axios/getFragmentDetailTranscription";
import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";

export const getFragmentDetailTranscriptionSuspenseQueryKey = (id: GetFragmentDetailTranscriptionPathParams["id"]) => ["web-app-bff-api", { url: '/fragments/:id/transcription', params: {id:id} }] as const

export type GetFragmentDetailTranscriptionSuspenseQueryKey = ReturnType<typeof getFragmentDetailTranscriptionSuspenseQueryKey>

export function getFragmentDetailTranscriptionSuspenseQueryOptions(id: GetFragmentDetailTranscriptionPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getFragmentDetailTranscriptionSuspenseQueryKey(id)
        return queryOptions<GetFragmentDetailTranscriptionQueryResponse, ResponseErrorConfig<GetFragmentDetailTranscription404>, GetFragmentDetailTranscriptionQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return getFragmentDetailTranscription(id, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get fragment transcription
 * {@link /fragments/:id/transcription}
 */
export function useGetFragmentDetailTranscriptionSuspense<TData = GetFragmentDetailTranscriptionQueryResponse, TQueryKey extends QueryKey = GetFragmentDetailTranscriptionSuspenseQueryKey>(id: GetFragmentDetailTranscriptionPathParams["id"], options: 
{
  query?: Partial<UseSuspenseQueryOptions<GetFragmentDetailTranscriptionQueryResponse, ResponseErrorConfig<GetFragmentDetailTranscription404>, TData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? getFragmentDetailTranscriptionSuspenseQueryKey(id)
         

         const query = useSuspenseQuery({
          ...getFragmentDetailTranscriptionSuspenseQueryOptions(id, config),
          queryKey,
          ...queryOptions
         } as unknown as UseSuspenseQueryOptions, queryClient) as UseSuspenseQueryResult<TData, ResponseErrorConfig<GetFragmentDetailTranscription404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}